import React, { useEffect, useState } from "react";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
function CenterOption({ onInputChange, defaultValuemain }) {

    const [data, setData] = useState([])

    const getdata = async () => {
        const sendData = {
            OrgId: Number(2),
            UserId: Number(localStorage.getItem("userIdA")),
        }
        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/DashboardDataAdmin', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setData(data)
                    ////console.log(data)
                })


    };
    useEffect(() => {
        getdata()
    }, [])


    return (
        <Box sx={{ minWidth: 120 }}>
        <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label" ><b>Center</b></InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={defaultValuemain}
                label="Center"
                onChange={onInputChange}
                >
                <MenuItem value={0}>All Center</MenuItem>
            {data !== [] ? data.map((optiondata,index) =>
                <MenuItem key={index+1} value={optiondata.userId}>{optiondata.state}</MenuItem>
                ):null
              }
            
            </Select>
            </FormControl>
        </Box>

    );
};

export default CenterOption;
